import { useState } from 'react';

interface UseDynamicFormSubmitOptions {
    onSubmit: (data: any) => Promise<void>;
    onClose: () => void;
    shouldRefresh?: boolean; // Optional: whether to refresh page after submit
}

export const useDynamicFormSubmit = ({ onSubmit, onClose, shouldRefresh = true }: UseDynamicFormSubmitOptions) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e: React.FormEvent, formData: Record<string, any>) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            await onSubmit(formData);
            // Conditionally refresh the page based on shouldRefresh flag
            if (shouldRefresh) {
                window.location.reload();
            }
            onClose();
        } catch (err) {
            console.error(err);
        } finally {
            setIsSubmitting(false);
        }
    };

    return {
        isSubmitting,
        handleSubmit,
    };
};
